import React from 'react';
import { SimpleSingleSelect } from '@/src/ui/SimpleForm';
import type { Option } from '@/src/utils';

interface StandardsFilterProps {
    grades: string[];
    selectedGrade: string | number;
    onGradeChange: (grade: string) => void;
}

const StandardsFilter: React.FC<StandardsFilterProps> = ({
    grades,
    selectedGrade,
    onGradeChange,
}) => {
    const options: Option[] = [{ id: '', name: 'All' }, ...grades.map((g) => ({ id: g, name: g }))];

    const gradeStr = typeof selectedGrade === 'string' ? selectedGrade : '';
    const value = gradeStr === '' ? 0 : grades.indexOf(gradeStr) + 1;
    return (
        <SimpleSingleSelect
            name="grade-select"
            label="Grade"
            value={value}
            onChange={(e) => {
                const idx = Number(e.target.value);
                onGradeChange(idx === 0 ? '' : grades[idx - 1]);
            }}
            options={options.map((opt, i) => ({ ...opt, id: i }))}
            sx={{ minWidth: 160, maxWidth: 220, mt: 0.5 }}
        />
    );
};

export default StandardsFilter;
